import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { getLocalizedSchedule, scheduleLabels } from '../../data/staticSchedule';
import { getLocalizedValue, siteContent } from '../../data/siteContent';

const PinIcon = () => (
	<svg viewBox="0 0 24 24" className="schedule-location-icon agua-teal-icon-shadow" aria-hidden="true">
		<path
			d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z"
			fill="currentColor"
		/>
	</svg>
);

const ScheduleSection = () => {
	const { language } = useLanguage();
	const labels = scheduleLabels[language] || scheduleLabels.en;
	const schedule = getLocalizedSchedule(language);
	const title = getLocalizedValue(siteContent.navigation.schedule, language);

	return (
		<section className="section schedule-section" id="schedule">
			<div className="container">
				<h2 className="section-title">{title}</h2>
				<div className="static-schedule" aria-label={labels.ariaLabel}>
					{schedule.map((location) => {
						const fullAddress = `${location.address}, ${location.postalCode} Rotterdam`;

						return (
							<a
								className="schedule-location"
								href={`https://maps.google.com/?q=${encodeURIComponent(fullAddress)}`}
								id={`location-${location.id}`}
								key={location.id}
								target="_blank"
								rel="noopener noreferrer"
							>
								<div className="schedule-location-title">
									<PinIcon />
									<span className="schedule-location-text">
										<span className="schedule-location-name">{location.locationName}</span>
										<span className="schedule-location-address">{location.address}</span>
									</span>
								</div>
								<div className="schedule-location-body">
									{location.days.map((day) => (
										<div className="schedule-day-group" key={`${location.id}-${day.id}`}>
											<h3 className="schedule-day-heading">{day.name}</h3>
											<div className="schedule-class-list">
												{day.classes.map((classItem) => (
													<div
														className="schedule-class-row"
														key={`${location.id}-${day.id}-${classItem.time}-${classItem.title}`}
													>
														<span className="schedule-class-time">{classItem.time}</span>
														<span className="schedule-class-name">{classItem.title}</span>
													</div>
												))}
											</div>
										</div>
									))}
								</div>
							</a>
						);
					})}
				</div>
			</div>
		</section>
	);
};

export default ScheduleSection;
